import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AcademicSessionMasterComponent } from './academic-session-master/academic-session-master.component';
import { BranchPatternMasterComponent } from './branch-pattern-master/branch-pattern-master.component';
import { HomeComponent } from './home/home.component';
import { StudentLoginComponent } from './student-login/student-login.component';
import { TeacherDataComponent } from './teacher-data/teacher-data.component';
import { FacultyDataComponent } from './faculty-data/faculty-data.component';
import { ParameterDataComponent } from './parameter-data/parameter-data.component';
import { ExamStreamDataComponent } from './exam-stream-data/exam-stream-data.component';
import { ParentsFormComponent } from './parents-form/parents-form.component';
import { ParentsDataComponent } from './parents-data/parents-data.component';
import { StudentDataComponent } from './student-data/student-data.component';
import { DistrictDataComponent } from './district-data/district-data.component';
import { CollegeDataComponent } from './college-data/college-data.component';
import { TownDataComponent } from './town-data/town-data.component';
import { CodeTypeDataComponent } from './code-type-data/code-type-data.component';
import { CourseDataComponent } from './course-data/course-data.component';
import { SessionDataComponent } from './session-data/session-data.component';
import { ExamSemesterDataComponent } from './exam-semester-data/exam-semester-data.component';
import { ExamDivisionDataComponent } from './exam-division-data/exam-division-data.component';
import { ExamDataComponent } from './exam-data/exam-data.component';
import { ExamSubDataComponent } from './exam-sub-data/exam-sub-data.component';
import { IntegratedCourseDataComponent } from './integrated-course-data/integrated-course-data.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { CodeDataComponent } from './code-data/code-data.component';
import { CollegeMappingComponent } from './college-mapping/college-mapping.component';
import { CountryDataComponent } from './country-data/country-data.component';
import { StateDataComponent } from './state-data/state-data.component';
import { DivisionDataComponent } from './division-data/division-data.component';
import { UsersComponent } from './users/users.component';
import { CourseBranchComponent } from './course-branch/course-branch.component';
import { SubjectMappingComponent } from './subject-mapping/subject-mapping.component';
import { ExamMasterComponent } from './exam-master/exam-master.component';
import { ExamAggregateComponent } from './exam-aggregate/exam-aggregate.component';
import { ExamSubComponent } from './exam-sub/exam-sub.component';
import { ExamHeadComponent } from './exam-head/exam-head.component';
import { ExamSubjectSetupComponent } from './exam-subject-setup/exam-subject-setup.component';
import { ExamTimetableComponent } from './exam-timetable/exam-timetable.component';
import { SessionCourseCollegeComponent } from './session-course-college/session-course-college.component';
import { SessionCutoffComponent } from './session-cutoff/session-cutoff.component';
import { StudentSettingsPageComponent } from './student-settings-page/student-settings-page.component';
import { ChoiceSubjectsComponent } from './choice-subjects/choice-subjects.component';
import { SupervisorCourseComponent } from './supervisor-course/supervisor-course.component';
import { SupervisorExamComponent } from './supervisor-exam/supervisor-exam.component';
import { ExamSettingPageComponent } from './exam-setting-page/exam-setting-page.component';
import { ExamScEditComponent } from './exam-sc-edit/exam-sc-edit.component';
import { ExamScheduleComponent } from './exam-schedule/exam-schedule.component';
import { CourseScheduleComponent } from './course-schedule/course-schedule.component';
import { CourseScEditComponent } from './course-sc-edit/course-sc-edit.component';
import { NewExamCodesComponent } from './new-exam-codes/new-exam-codes.component';
import { ResultProcessingOneComponent } from './result-processing-one/result-processing-one.component';
import { AssignRegistrationNumberComponent } from './assign-registration-number/assign-registration-number.component';
import { CenterCodesComponent } from './center-codes/center-codes.component';
import { QuestionPaperCodeComponent } from './question-paper-code/question-paper-code.component';
import { ExamInputFormComponent } from './exam-input-form/exam-input-form.component';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { CenterAllocationComponent } from './center-allocation/center-allocation.component';
import { MarksEntryComponent } from './marks-entry/marks-entry.component';
import { ZoneComponent } from './zone/zone.component';
import { AssignVenueComponent } from './assign-venue/assign-venue.component';
import { PackingListComponent } from './packing-list/packing-list.component';
import { EnrollmentComponent } from './enrollment/enrollment.component';
import { AdmissionComponent } from './admission/admission.component';
import { EligibilityComponent } from './eligibility/eligibility.component';
import { IncentiveMarksComponent } from './incentive-marks/incentive-marks.component';
import { SubjectChangeComponent } from './subject-change/subject-change.component';
import { AssesmentMarksEntryComponent } from './assesment-marks-entry/assesment-marks-entry.component';
import { ReAddmissionComponent } from './re-addmission/re-addmission.component';
import { DebarExamLimitComponent } from './debar-exam-limit/debar-exam-limit.component';
import { TransferCourseComponent } from './transfer-course/transfer-course.component';
import { UpdatedResultComponent } from './updated-result/updated-result.component';
import { SubjectGraceComponent } from './subject-grace/subject-grace.component';
import { StudentStatusComponent } from './student-status/student-status.component';
import { PreviousExamComponent } from './previous-exam/previous-exam.component';
import { PaperEvaluatoionComponent } from './paper-evaluatoion/paper-evaluatoion.component';
import { RevaluationResultComponent } from './revaluation-result/revaluation-result.component';
import { UserTabComponent } from './user-tab/user-tab.component';
import { UserMasterComponent } from './user-master/user-master.component';
import { PermissionComponent } from './permission/permission.component';
import { MasterComponent } from './master/master.component';
import { AdminComponent } from './admin/admin.component';
import { SupervisorComponent } from './supervisor/supervisor.component';
import { ProcessingComponent } from './processing/processing.component';
import { InputComponent } from './input/input.component';
import { ReportCourseComponent } from './report-course/report-course.component';
import { ReportExamComponent } from './report-exam/report-exam.component';
import { ReportFootersComponent } from './report-footers/report-footers.component';
import { AssignLevelsComponent } from './assign-levels/assign-levels.component';
import { ScrutinyComponent } from './scrutiny/scrutiny.component';
import { StudentDetailsComponent } from './student-details/student-details.component';
import { StudentHistoryComponent } from './student-history/student-history.component';
import { FeesHeadComponent } from './fees-head/fees-head.component';
import { FeeTempletComponent } from './fee-templet/fee-templet.component';
import { FeeTempletMappingComponent } from './fee-templet-mapping/fee-templet-mapping.component';
import { ApplyFeeTemplateComponent } from './apply-fee-template/apply-fee-template.component';
import { FeeSettingComponent } from './fee-setting/fee-setting.component';
import { FeesMasterComponent } from './fees-master/fees-master.component';
import { FeeProcessComponent } from './fee-process/fee-process.component';
import { ReportsComponent } from './reports/reports.component';
import { SettingComponent } from './setting/setting.component';
import { ReportsDashboardComponent } from './reports-dashboard/reports-dashboard.component';
import { StudentAtdComponent } from './student-atd/student-atd.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { TehasilComponent } from './tehasil/tehasil.component';
import { UserToSubjectComponent } from './user-to-subject/user-to-subject.component';
import { SearchRegnFormsComponent } from './search-regn-forms/search-regn-forms.component';
import { SearchExamFormsComponent } from './search-exam-forms/search-exam-forms.component';
import { StdAtdSettingsComponent } from './std-atd-settings/std-atd-settings.component';
import { IaAtdComponent } from './ia-atd/ia-atd.component';
import { IaAtdSettingComponent } from './ia-atd-setting/ia-atd-setting.component';
import { CastWiseIntakeComponent } from './cast-wise-intake/cast-wise-intake.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ScrutinyReportComponent } from './scrutiny-report/scrutiny-report.component';
import { FeeReportsComponent } from './fee-reports/fee-reports.component';
import { DownloadDetailsComponent } from './download-details/download-details.component';
import { FeebypassComponent } from './feebypass/feebypass.component';
import { ExamFeeComponent } from './exam-fee/exam-fee.component';
import { ReportmenuComponent } from './reportmenu/reportmenu.component';
import { HolidayDatesComponent } from './holiday-dates/holiday-dates.component';
import { ParameterPopupComponent } from './parameter-popup/parameter-popup.component';
import { ComplaintComponent } from './complaint/complaint.component';
import { ComplaintFormComponent } from './complaint-form/complaint-form.component';
import { TransferScrutinyComponent } from './transfer-scrutiny/transfer-scrutiny.component';
import { TclcApprovalComponent } from './tclc-approval/tclc-approval.component';
import { CasteMasterComponent } from './caste-master/caste-master.component';
import { CategoryComponent } from './category/category.component';
import { PayGatewayComponent } from './pay-gateway/pay-gateway.component';
import { GrievanceApprovalLevelComponent } from './grievance-approval-level/grievance-approval-level.component';
import { WithHoldComponent } from './with-hold/with-hold.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { SlmComponent } from './slm/slm.component';
import { AdminNotificationsComponent } from './admin-notifications/admin-notifications.component';
import { TentativeScheduleComponent } from './tentative-schedule/tentative-schedule.component';
import { TentativeScheduleDetailsComponent } from './tentative-schedule-details/tentative-schedule-details.component';
import { TentativeScheduleMasterComponent } from './tentative-schedule-master/tentative-schedule-master.component';
import { TeacherProfileComponent } from './teacher-profile/teacher-profile.component';
import { DepartmentComponent } from './department/department.component';
import { DepartmentSubjectMappingComponent } from './department-subject-mapping/department-subject-mapping.component';
import { AssignTeacherDataComponent } from './assign-teacher-data/assign-teacher-data.component';
import { UpdateTeacherProfileComponent } from './update-teacher-profile/update-teacher-profile.component';
import { PracticalTimeTableComponent } from './practical-time-table/practical-time-table.component';
import { CollegeCapacityComponent } from './college-capacity/college-capacity.component';
import { TeacherAvailibiltyDataComponent } from './teacher-availibilty-data/teacher-availibilty-data.component';
import { StudentSignPhotoUploadComponent } from './student-sign-photo-upload/student-sign-photo-upload.component';
import { ExamFormReportCollegewiseComponent } from './exam-form-report-collegewise/exam-form-report-collegewise.component';
import { EligiblityForTeacherComponent } from './eligiblity-for-teacher/eligiblity-for-teacher.component';
import { IaUserAccessComponent } from './ia-user-access/ia-user-access.component';
import { IaMarksComponent } from './ia-marks/ia-marks.component';
import { IAMarkCountReportComponent } from './iamark-count-report/iamark-count-report.component';
import {UploadStudentDataComponent} from './upload-student-data/upload-student-data.component';
import{OldStudentSigphUploadComponent} from './old-student-sigph-upload/old-student-sigph-upload.component';
import{ConvocationComponent } from './convocation/convocation.component';
import { IAMarksReportComponent } from './ia-marks-report/ia-marks-report.component';
import { HbsReportsComponent } from './hbsreports/hbsreports.component';
import { TeacherEligibilityComponent } from './teacher-eligibility/teacher-eligibility.component';
import { PracticalMarksComponent } from './practical-markentry/practical-markentry.component';
import { BatchFreezeComponent } from './batch-freeze/batch-freeze.component';
import { StudentSignPhotoUploadReportComponent } from './student-sign-photo-upload-report/student-sign-photo-upload-report.component';
import { AdminOptionalSubjectSelectionComponent } from './admin-optional-subject-selection/admin-optional-subject-selection.component';
import { TheoryExamAppointmentComponent } from './theory-exam-appointment-component/theory-exam-appointment-component.component';
import { TheoryExamAppointmentReportComponent } from './theory-exam-appointment-report/theory-exam-appointment-report.component';
import { ElectiveMarksComponent } from './elective-marks/elective-marks.component';
import { CollegewiseStudentNameListComponent } from './collegewise-student-name-list/collegewise-student-name-list.component';
import { StudentHoldDetailsComponent } from './student-hold-details/student-hold-details.component';
import { NewCenterAllocationComponent } from './new-center-allocation/new-center-allocation.component';
import { AssignPanelDateComponent } from './assign-panel-date/assign-panel-date.component';
import { MarksheetLedgerComponent } from './marksheet-ledger/marksheet-ledger.component';
import { PracticalMarksReportComponent } from './practical-marks-report/practical-marks-report.component';
import { BufferStudentAnswersheetCodeEntryComponent } from './buffer-student-answersheet-code-entry/buffer-student-answersheet-code-entry.component';
import { MarksDataUploadSheetsComponent } from './marks-data-upload-sheets/marks-data-upload-sheets.component';
import { BlockWiseReportComponent } from './block-wise-report/block-wise-report.component';
import { AttendanceSheetsComponent } from './attendance-sheets/attendance-sheets.component';
import { ExamsEvalMarksReportComponent } from './exams-eval-marks-report/exams-eval-marks-report.component';
import { CollegeMarksheetLedgerComponent } from './college-marksheet-ledger/college-marksheet-ledger.component';
import { CoursewiseAttThresoldMasterComponent } from './coursewise-att-thresold-master/coursewise-att-thresold-master.component';
import { EligibilityCriteriaComponent } from './eligibility-criteria/eligibility-criteria.component';

const routes: Routes = [
  // {
  //   path: 'home',
  //   component: HomeComponent,
  // },
  {
   path: 'marksheet-ledger',
  component: MarksheetLedgerComponent
  },
  {
   path: 'college-marksheet-ledger',
  component: CollegeMarksheetLedgerComponent
  },
  {
    path: 'convocation',
    component: ConvocationComponent,
    data: { name: "Convocation", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
     path:'Student-Hold-Data',
     component: StudentHoldDetailsComponent,
     data: { name: "Student-Hold-Data", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'OldStudentSigphUpload',
    component: OldStudentSigphUploadComponent,
    data: { name: "Upload Old Student Photo And Sign", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'login',
    component: StudentLoginComponent,
  },
  {
    path: 'parents-form',
    component: ParentsFormComponent,
  },
  {
    path: 'parents-data',
    component: ParentsDataComponent,
  },
  {
    path: 'branch-pattern-master',
    component: BranchPatternMasterComponent
  },
  {
    path: 'academic-session-master',
    component: AcademicSessionMasterComponent
  },
  // {
  //   path: 'dashboard',
  //   component: DashboardComponent,
  //   data:{name:"Dashboard",IsTab:false,MenuName:"Dashboard1"}
  // },
  {
    path: 'home',
    component: HomeComponent,
    data: { name: "Dashboard", IsTab: false, MenuName: "Dashboard" }
  },
  {
    path: 'admin',
    component: AdminComponent,
    data: { name: "Admin", IsTab: false, MenuName: "Admin" }
  },
  {
    path: 'session-data',
    component: SessionDataComponent,
    data: { name: "Session", IsTab: true, isadmin: true, MenuName: "Admin" }
  },
    {
    path: 'marks-data-upload-sheets',
    component: MarksDataUploadSheetsComponent,
    data: { name: "marks-data-upload-sheets", IsTab: true, isProcc: true, MenuName: "Processing" }
  },
   {
    path: 'buffer-student-answersheet-code-entry',
    component: BufferStudentAnswersheetCodeEntryComponent,
    data: { name: "Buffer_Student_Answersheet", IsTab: true, isProcc: true, MenuName: "Processing" }
  },
  {
    path: 'exams-eval-marks-report',
    component: ExamsEvalMarksReportComponent,
    data: { name: "ExamsEvalMarksReportComponent", IsTab: true, isProcc: true, MenuName: "Processing" }
  },
  
  {
    path: 'session-course-college',
    component: SessionCourseCollegeComponent,
    data: { name: "Course Intake Mapping", IsTab: true, isadmin: true, MenuName: "Admin" }
  },
  {
    path: 'CasteWiseIntake',
    component: CastWiseIntakeComponent,
    data: { name: "Caste Wise Intake", IsTab: true, isadmin: true, MenuName: "Admin" }
  },
  {
    path: 'session-cutoff',
    component: SessionCutoffComponent,
    data: { name: "Session-Cutoff", IsTab: true, isadmin: true, MenuName: "Admin" }
  },
  {
    path: 'supervisor-course',
    component: SupervisorCourseComponent,
    data: { name: "Supervisor-Course", IsTab: true, isadmin: true, MenuName: "Admin" }
  },
  {
    path: 'supervisor-exam',
    component: SupervisorExamComponent,
    data: { name: "Supervisor-Exam", IsTab: true, isadmin: true, MenuName: "Admin" }
  },

  {
    path: 'user-tab',
    component: UserTabComponent,
    data: { name: "User-Permission", IsTab: true, isadmin: true, MenuName: "Admin" }

  },


  {
    path: 'assign-level',
    component: AssignLevelsComponent,
    data: { name: "Admission Approval Level", IsTab: true, isadmin: true, MenuName: "Admin" }
  },

  {
    path: 'change-password',
    component: ChangePasswordComponent,
    data: { name: "Change Password", IsTab: true, isadmin: true, MenuName: "Admin" }
  },
  {
    path: 'Ia-User-Access',
    component: IaUserAccessComponent,
     data:{name:"IA Marks User Access",IsTab:true,isadmin:true,MenuName:"Admin"}
  },
  // {
  //   path: 'UserToSubject',
  //   component:  UserToSubjectComponent,
  //   data:{name:"User To Subject",IsTab:true,isadmin:true,MenuName:"Admin"}
  // },
  {
    path: 'search-registration',
    component: SearchRegnFormsComponent,
    // data:{name:"Admission Approval Level",IsTab:true,isadmin:true,MenuName:"Admin"}
  },
  {
    path: 'FeebypassComponent',
    component: FeebypassComponent,
  },
  {
    path: 'Search-Scrutiny-Report',
    component: ScrutinyReportComponent,
    // data:{name:"Admission Approval Level",IsTab:true,isadmin:true,MenuName:"Admin"}
  },
  {
    path: 'search-exam',
    component: SearchExamFormsComponent,
    // data:{name:"Admission Approval Level",IsTab:true,isadmin:true,MenuName:"Admin"}
  },
   { 
  path: 'Theory-Exam-Appointment', 
  component: TheoryExamAppointmentComponent
 },

 {
  path: 'theory-exam-appointment-report',
  component: TheoryExamAppointmentReportComponent
},
  {
    path: 'Input',
    component: InputComponent,
    data: { name: "Input", IsTab: false, MenuName: "Input" }
  },

  {
    path: 'Registration-Form',
    component: RegistrationFormComponent,
    data: { name: "Registration Form", IsTab: true, isInput: true, MenuName: "Input" }
  },
  {
    path: 'Exam-Input-Form',
    component: ExamInputFormComponent,
    data: { name: "Exam Input Form", IsTab: true, isInput: true, MenuName: "Input" }
  },

  {
    path: 'Center-Allocation',
    component: CenterAllocationComponent,
    data: { name: "Center Allocation", IsTab: true, isInput: true, MenuName: "Input" }
  },
   {
    path: 'new-center-allocation',
    component: NewCenterAllocationComponent,
    data: { name: "Center Allocation and Seat No", IsTab: true, isInput: true, MenuName: "Input" }
  },

  {
    path: 'Marks-Entry',
    component: MarksEntryComponent,
    data: { name: "Barcode Name Slips", IsTab: true, isInput: true, MenuName: "Input" }
  },

  {
    path: 'Marks-Entry',
    component: MarksEntryComponent,
    data: { name: "Barcode Marks Slips", IsTab: true, isInput: true, MenuName: "Input" }
  },
  {
    path: 'Marks-Entry',
    component: MarksEntryComponent,
    data: { name: "Control Sheets", IsTab: true, isInput: true, MenuName: "Input" }
  },
  {
    path: 'Marks-Entry',
    component: MarksEntryComponent,
    data: { name: "Marks By RollNo", IsTab: true, isInput: true, MenuName: "Input" }
  },
  {
    path:'Practical-Marks',
    component: PracticalMarksComponent,
    data: { name: "Practical Marks", IsTab: true, isInput: true, MenuName: "Input" }

  },
  {
    path: 'Marks-Entry',
    component: MarksEntryComponent,
    data: { name: "Marks By Code", IsTab: true, isInput: true, MenuName: "Input" }
  },
  {
    path: 'Marks-Entry',
    component: MarksEntryComponent,
    data: { name: "Status Report", IsTab: true, isInput: true, MenuName: "Input" }
  },
  {
    path: 'Marks-Entry',
    component: MarksEntryComponent,
    data: { name: "Change Marks", IsTab: true, isInput: true, MenuName: "Input" }
  },
  {
    path: 'Marks-Entry',
    component: MarksEntryComponent,
    data: { name: "Section Marks", IsTab: true, isInput: true, MenuName: "Input" }
  },
  {
    path: 'Marks-Entry',
    component: MarksEntryComponent,
    data: { name: "Dist Ass Marks", IsTab: true, isInput: true, MenuName: "Input" }
  },

  {
    path: 'Student-Status',
    component: StudentStatusComponent,
    data: { name: "Student Status", IsTab: true, isInput: true, MenuName: "Input" }
  },
  {
    path: 'Upload-Student-Data',
    component: UploadStudentDataComponent,
    data: { name: "Upload-Student-Data", IsTab: true, isInput: true, MenuName: "Input" }
  },
   {
    path: 'packing-list',
    component: PackingListComponent,
    // data:{name:"Packing-List",IsTab:false}
    data: { name:"Packing List", IsTab: true, isInput: true, MenuName: "Input" }
  },
  {
    path: 'subject-change',
    component: SubjectChangeComponent,
    // data:{name:"Subject-Change",IsTab:false}
      data: { name:"Subject Change", IsTab: true, isInput: true, MenuName: "Input" }
  },
 {
  path: 'admin-optional-subject-selection',
  component: AdminOptionalSubjectSelectionComponent,
  data: {name: 'Optional Subject Selection',IsTab: true,isInput: true,MenuName: 'Input'}
  },
  {
    path: 'revaluation-result',
    component: RevaluationResultComponent,
    data: { name: "RevaluationView", IsTab: true, isInput: true, MenuName: "Input" }
  },
   {
    path: 'with-hold',
    component: WithHoldComponent,
    data: { name: "With Hold", IsTab: true, isInput: true, MenuName: "Input" }
  },

  {
    path: 'master',
    component: MasterComponent,
    data: { name: "Master", IsTab: false, MenuName: "Master" }
  },
  {
    path: 'college-data',
    component: CollegeDataComponent,
    data: { name: "College", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'faculty-data',
    component: FacultyDataComponent,
    data: { name: "Faculty", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'course-data',
    component: CourseDataComponent,
    data: { name: "Course", IsTab: true, isMaste: true, MenuName: "Master" }
    // used
  },
    {
    path: 'coursewise-att-thresold-master',
    component: CoursewiseAttThresoldMasterComponent,
    data: { name: "Coursewise Attendance Threshold", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'exam-stream-data',
    component: ExamStreamDataComponent,
    data: { name: "Branch/Stream", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'college-mapping',
    component: CollegeMappingComponent,
    data: { name: "College-Mapping", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'code-type-data',
    component: CodeTypeDataComponent,
    data: { name: "Code-Type", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'code-data',
    component: CodeDataComponent,
    data: { name: "Code", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'exam-data',
    component: ExamDataComponent,
    data: { name: "Exam", IsTab: true, isMaste: true, MenuName: "Master" },
    // data:{name:"Master",IsTab:false}
  },
  {
    path: 'exam-division-data',
    component: ExamDivisionDataComponent,
    data: { name: "Exam-Division", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'exam-aggregate',
    component: ExamAggregateComponent,
    data: { name: "Exam-Aggrigate", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'exam-semester',
    component: ExamSemesterDataComponent,
    data: { name: "Exam-Semester", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  // {
  //   path: 'subject-mapping',
  //   component: SubjectMappingComponent,
  //   data:{name:"subject-setup",IsTab:true,isMaste:true,MenuName:"Master"}
  // },
  {
    path: 'exam-subject-setup',
    component: ExamSubjectSetupComponent,
    data: { name: "Subject-setup", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'Choice-Subjects',
    component: ChoiceSubjectsComponent,
    data: { name: "Choice-Subject", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'country-data',
    component: CountryDataComponent,
    data: { name: "Country", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'state-data',
    component: StateDataComponent,
    data: { name: "State", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'district-data',
    component: DistrictDataComponent,
    data: { name: "District", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'division-data',
    component: DivisionDataComponent,
    data: { name: "Division", IsTab: true, isMaste: true, MenuName: "Master" }
  },

  {
    path: 'town-data',
    component: TownDataComponent,
    data: { name: "Town", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'tehasil-data',
    component: TehasilComponent,
    data: { name: "Tehasil", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'student-attendance-setting',
    component: StdAtdSettingsComponent,
    data: { name: "Subject Attendance", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'ia-attendance',
    component: IaAtdSettingComponent,
    data: { name: "Practical Attendance", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'Department',
    component: DepartmentComponent,
    data: { name: "Department", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'Department-Subject-Mapping',
    component: DepartmentSubjectMappingComponent,
    data: { name: "Department-Subject-Mapping", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'Teacher-Data',
    component: TeacherDataComponent,
    data: { name: "Examiner Profile", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'TeacherAvailibilty',
    component: TeacherAvailibiltyDataComponent,
    data: { name: "Examiner Availability Request", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'eligibility-criteria',
    component: EligibilityCriteriaComponent,
     data: { name: "Eligibility Criteria", IsTab: true, isMaste: true, MenuName: "Master" }
  },
  {
    path: 'TeacherEligibility',
    component: TeacherEligibilityComponent,
    data: { name: "Examiner Eligibility Add", IsTab: true, isMaste: true, MenuName: "Master" }
  },

  {
    path: 'AssignTeacher-Data',
    component: AssignTeacherDataComponent,
    data: { name: "Practical Examiner Assignment", IsTab: true, isMaste: true, MenuName: "Master" }
  },

  {
    path: 'Processing',
    component: ProcessingComponent,
    data: { name: "Processing", IsTab: false, MenuName: "Processing" }
  },
  {
    path: 'assign-registration',
    component: AssignRegistrationNumberComponent,
    data: { name: "Generate RegnNo", IsTab: true, isProcc: true, MenuName: "Processing" }
  },
  {
    path: 'result-process',
    component: ResultProcessingOneComponent,
    data: { name: "Generate Roll No", IsTab: true, isProcc: true, MenuName: "Processing", MCode: 'O' }
  },
  {
    path: 'result-process',
    component: ResultProcessingOneComponent,
    data: { name: "Generate Control Sheet", IsTab: true, isProcc: true, MenuName: "Processing", MCode: '' }
  },
  {
    path: 'result-process',
    component: ResultProcessingOneComponent,
    data: { name: "Generate Codes", IsTab: true, isProcc: true, MenuName: "Processing", MCode: 'D' }
  },
  {
    path: 'center-codes',
    component: CenterCodesComponent,
    data: { name: "Center Codes", IsTab: true, isProcc: true, MenuName: "Processing" }
  },
  {
    path: 'result-process',
    component: ResultProcessingOneComponent,
    data: { name: "Zone Allocation", IsTab: true, isProcc: true, MenuName: "Processing", MCode: '' }
  },

  {
    path: 'result-process',
    component: ResultProcessingOneComponent,
    data: { name: "Generate Marks Foils", IsTab: true, isProcc: true, MenuName: "Processing", MCode: 'F' }
  },
  {
    path: 'result-process',
    component: ResultProcessingOneComponent,
    data: { name: "Process Result", IsTab: true, isProcc: true, MenuName: "Processing", MCode: 'R' }
  },
  {
    path: 'result-process',
    component: ResultProcessingOneComponent,
    data: { name: "Update Results", IsTab: true, isProcc: true, MenuName: "Processing", MCode: 'U' }
  },
  {
    path: 'result-process',
    component: ResultProcessingOneComponent,
    data: { name: "Re-Process Result (Changes)", IsTab: true, isProcc: true, MenuName: "Processing", MCode: 'RP' }
  },
  {
    path: 'session-data',
    component: SessionDataComponent,
    data: { name: "Switch Session", IsTab: true, isProcc: true, MenuName: "Processing" }
  },
  {
    path: 'Setting',
    component: SettingComponent,
    data: { name: "Setting", IsTab: false, MenuName: "Setting" }
  },
  {
    path: 'student-profile-settings',
    component: StudentSettingsPageComponent,
    data: { name: "Student Profile Setting", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'exam-setup',
    component: ExamSettingPageComponent,
    data: { name: "Exam Setup", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'Fee-Head',
    component: FeesHeadComponent,
    data: { name: "Fee Head", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'Fee-Templet',
    component: FeeTempletComponent,
    data: { name: "Fee Template", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'Fee-Templet-Mapping',
    component: FeeTempletMappingComponent,
    data: { name: "Fee Template Mapping", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'Fee-Setting',
    component: FeeSettingComponent,
    data: { name: "Fee Mode", IsTab: true, isSetting: true, MenuName: "Setting" }
  },


  {
    path: 'apply-fee',
    component: ApplyFeeTemplateComponent,
    data: { name: "Apply Admission Fee", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'Exam-Fee',
    component: ExamFeeComponent,
    data: { name: "Apply Exam Fee", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'scrutiny',
    component: ScrutinyComponent,
    data: { name: "Scrutiny Approval", IsTab: true, isSetting: true, MenuName: "Setting" }

  },
  {
    path: 'student-attendance',
    component: StudentAtdComponent,
    data: { name: "Student Attendance", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'student-ia-attendance',
    component: IaAtdComponent,
    data: { name: "Student Practical Attendance", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'Fee-Process',
    component: FeeProcessComponent,
    // data:{name:"Fee-Process",IsTab:true,isInput:true,MenuName:"Fee"}
  },
  {
    path: 'holiday-dates',
    component: HolidayDatesComponent,
    data: { name: "Holiday Date", IsTab: true, isSetting: true, MenuName: "Setting" }
  },

  {
    path: 'parameter-data',
    component: ParameterDataComponent,
    data: { name: "Parameter", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'complaint',
    component: ComplaintComponent,
    data: { name: "Grievance", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    data: { name: "Publish Notification", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'tentative-schedule-master',
    component: TentativeScheduleMasterComponent,
    data: { name: "Tentative Exam Schedule", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'tentative-schedule-details',
    component: TentativeScheduleDetailsComponent,
    data: { name: "Tentative Descriptive Schedule", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'StudentSignPhotoUpload',
    component: StudentSignPhotoUploadComponent,
    data: { name: "Upload Student Photo And Sign", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'ExamFormReportCollegewise',
    component: ExamFormReportCollegewiseComponent,
    data: { name: "Student Exam Form College Report", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
   {
    path: 'IAMarks',
    component: IaMarksComponent,
    data: { name: "IA Marks", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
   {
    path: 'ElectiveMarks',
    component: ElectiveMarksComponent,
    data: { name: "Elective Marks", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
   {
    path: 'IAMarkCountReport',
    component: IAMarkCountReportComponent,
    data: { name: "IA Count Report", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'IA-Marks-Report',
    component: IAMarksReportComponent,
    data: { name: "IA-Marks-Report", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
   {
    path: 'practical-marks-report',
    component: PracticalMarksReportComponent,
    data: { name: "PracticalMarksReport", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'collegewise-student-name-list',
    component: CollegewiseStudentNameListComponent,
    data: { name: "collegewise-student-name-list", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
   {
    path: 'student-sign-photo-upload-report',
    component: StudentSignPhotoUploadReportComponent,
    data: { name: "student-sign-photo-upload-report", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
   {
    path: 'Block-Wise-Report',
    component: BlockWiseReportComponent,
    data: { name: "Block-Wise-Report", IsTab: true, isSetting: true, MenuName: "Setting" }
  },
  {
    path: 'Supervisor',
    component: SupervisorComponent,
    data: { name: "Supervisor", IsTab: false, MenuName: "Supervisor" }
  },
  {
    path: 'Practical-Marks',
    component: PracticalMarksComponent,
  },
  {
    path: 'exam-schedule',
    component: ExamScheduleComponent,
    data: { name: "Exam-Schedule", IsTab: true, isSuper: true, MenuName: "Supervisor" }
  },
  {
    path: 'exam-sc-edit',
    component: ExamScEditComponent,
    data: { name: "Exam-Edit-Control", IsTab: true, isSuper: true, MenuName: "Supervisor" }
  },
  {
    path: 'course-schedule',
    component: CourseScheduleComponent,
    data: { name: "Course-Schedule", IsTab: true, isSuper: true, MenuName: "Supervisor" }
  },
  {
    path: 'course-sc-edit',
    component: CourseScEditComponent,
    data: { name: "Course-Edit-Control", IsTab: true, isSuper: true, MenuName: "Supervisor" }
  },
  {
    path: 'new-exam-code',
    component: NewExamCodesComponent,
    data: { name: "New-Exam-Code", IsTab: true, isSuper: true, MenuName: "Supervisor" }
  },
  {
    path: 'exam-timetable',
    component: ExamTimetableComponent,
    data: { name: "Exam-Timetable", IsTab: true, isSuper: true, MenuName: "Supervisor" }
  },
  {
    path: 'Question-Papers-Codes',
    component: QuestionPaperCodeComponent,
    data: { name: "Question-Paper-Codes", IsTab: true, isSuper: true, MenuName: "Supervisor" }
  },
  {
    path: 'practicalTimeTable',
    component: PracticalTimeTableComponent,
    data: { name: "Practical TimeTable", IsTab: true, isSuper: true, MenuName: "Supervisor" }
  },
  {
    path: 'AssignPanelDate',
    component: AssignPanelDateComponent,
    data: { name: "Assign Panel Date", IsTab: true, isSuper: true, MenuName: "Supervisor" }
  },
   {
    path: 'practicalBatch',
    component: BatchFreezeComponent,
    data: { name: "Practical Batch", IsTab: true, isSuper: true, MenuName: "Supervisor" }
  },
  {
    path: 'Reports',
    component: ReportmenuComponent,
    data: { name: "Reports", IsTab: false, MenuName: "Reports" }
  },



  {
    path: 'parameter',
    component: ParameterPopupComponent
  },
  {
    path: 'student-data',
    component: StudentDataComponent
  },

  {
    path: 'user-master',
    component: UserMasterComponent
  },
  {
    path: 'permission-master',
    component: PermissionComponent
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
  },
  {
    path: 'exam-sub-data',
    component: ExamSubDataComponent,
    // data:{name:"Exam-Subject",IsTab:false}
  },
  {
    path: 'integrated-course-data',
    component: IntegratedCourseDataComponent
  },


  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'sign-up',
    component: SignUpComponent
  },


  {
    path: 'course-branch',
    component: CourseBranchComponent
  },

  {
    path: 'exam-sub',
    component: ExamSubComponent
  },
  {
    path: 'user',
    component: UsersComponent
  },
  {
    path: 'exam-master',
    component: ExamMasterComponent
  },

  {
    path: 'exam-head',
    component: ExamHeadComponent
  },
  {
    path: 'Zones',
    component: ZoneComponent,
    // data:{name:"Zones",IsTab:false}
  },
  {
    path: 'assign-venue',
    component: AssignVenueComponent,
    // data:{name:"Assign-Venue",IsTab:false}
  },
  {
    path: 'enrollment',
    component: EnrollmentComponent,
    // data:{name:"Enrollment",IsTab:false}
  },
  {
    path: 'admission',
    component: AdmissionComponent,
    //  data:{name:"Addmission",IsTab:false}
  },
  {
    path: 'eligibility',
    component: EligibilityComponent,
    // data:{name:"Eligibility",IsTab:false}
  },
  {
    path: 'incentive-marks',
    component: IncentiveMarksComponent,
    // data:{name:"Incentive-Marks",IsTab:false}
  },

  {
    path: 'Assesment-MarksEntry',
    component: AssesmentMarksEntryComponent,
    //  data:{name:"Assesment-MarksEntry",IsTab:false}
  },
  {
    path: 'Re-Addmission',
    component: ReAddmissionComponent,
    // data:{name:"ReAddmission",IsTab:false}
  },
  {
    path: 'Debar-ExamLimit',
    component: DebarExamLimitComponent
  },


  {
    path: 'Transfer-Course',
    component: TransferCourseComponent
  },
  {
    path: 'Updated-Result',
    component: UpdatedResultComponent
  },
  {
    path: 'Subject-Grace',
    component: SubjectGraceComponent
  },


  {
    path: 'Previous-Exam',
    component: PreviousExamComponent
  },
  {
    path: 'PaperEvaluatoion',
    component: PaperEvaluatoionComponent
  },
  {
    path: 'download-details',
    component: DownloadDetailsComponent
  },
  {
    path: 'report-course',
    component: ReportCourseComponent
  },
  {
    path: 'report-exam',
    component: ReportExamComponent
  },
     {
    path: 'Attendance-Sheets',
    component: AttendanceSheetsComponent
  },
  {
    path: 'report-footer',
    component: ReportFootersComponent
  },

  {
    path: 'student-profile',
    component: StudentDetailsComponent
  },
  {
    path: 'student-history',
    component: StudentHistoryComponent
  },
  {
    path: 'reports',
    component: ReportsComponent
  },
  {
    path: 'hbsreports',
    component: HbsReportsComponent
  },
  {
    path: 'fee-reports',
    component: FeeReportsComponent
  },

  {
    path: 'reportDashboard',
    component: ReportsDashboardComponent
  },
  {
    path: 'CasteWiseIntake',
    component: CastWiseIntakeComponent
  },
  {
    path: 'HomePage',
    component: DashboardComponent,
  },


  {
    path: 'complaint-form',
    component: ComplaintFormComponent,
  },
  {
    path: 'TclcScrutiny',
    component: TransferScrutinyComponent,
  },
  {
    path: 'TclcApproval',
    component: TclcApprovalComponent,
  },
  {
    path: 'caste-master',
    component: CasteMasterComponent,
  },
  {
    path: 'category',
    component: CategoryComponent,
  },
  {
    path: 'pay-gateway',
    component: PayGatewayComponent,

  },
  {
    path: 'grievance-approval-level',
    component: GrievanceApprovalLevelComponent,
  },
  {
    path: 'adminNotification',
    component: AdminNotificationsComponent,
  },
  {
    path: 'slm',
    component: SlmComponent,
  },

  {
    path: 'tentative-schedule',
    component: TentativeScheduleComponent,
  },
  {
    path: 'Teacher',
    component: TeacherProfileComponent,
  },
  {
    path: 'EditTeacherProfile',
    component: UpdateTeacherProfileComponent,
  },
 
  {
    path: 'college-capacity',
    component: CollegeCapacityComponent,
  },
  {
    path: 'EligiblityForTeacher',
    component: EligiblityForTeacherComponent,
  },

  // records
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
